import { formUrl } from 'shared/utils/links/form-url'

export const flutterwaveWebhookUrl = formUrl('/payment/webhook/listening-flutterwave', false)
